<nz-spin [nzSpinning]="loading">
    @if (usersHelpMaterials) {
        @if (usersHelpMaterials.fileTypeMaterials?.length > 0) {
            <nz-row>
                <nz-col>
                    <h3 class="mb-3">Faili, attēli, video</h3>
                    @for (fileMaterial of usersHelpMaterials.fileTypeMaterials; track fileMaterial.id) {
                        <div class="row align-items-center">
                            <span nz-icon nzType="download" nzTheme="outline"></span>
                            <a nz-button nzType="link" (click)="downloadFileMaterial(fileMaterial.id)" class="h-auto break-text">
                                {{ fileMaterial.displayName }}
                            </a>
                        </div>
                    }
                </nz-col>
            </nz-row>
        }

        @if (usersHelpMaterials.urlTypeMaterials?.length > 0) {
            <nz-row>
                <nz-col>
                    <h3 class="mb-2 mt-3">Saites</h3>
                    @for (urlMaterial of usersHelpMaterials.urlTypeMaterials; track urlMaterial.id) {
                        <div class="row align-items-center">
                            <span nz-icon nzType="link" nzTheme="outline"></span>
                            <a nz-button nzType="link" (click)="gotoUrlMaterial(urlMaterial)" class="h-auto break-text">
                                {{ urlMaterial.displayName }}
                            </a>
                        </div>
                    }
                </nz-col>
            </nz-row>
        }

        @if (usersHelpMaterials.youTubeVideos?.length > 0) {
            <nz-row>
                <nz-col>
                    <h3 class="mb-2 mt-3">YouTube video</h3>
                    @for (ytMaterial of usersHelpMaterials.youTubeVideos; track ytMaterial.id) {
                        <div class="mb-3">
                            <h4>{{ ytMaterial.displayName }}</h4>
                            <iframe
                                width="560"
                                height="315"
                                [src]="ytMaterial.url | safeYoutube"
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen
                            ></iframe>
                        </div>
                    }
                </nz-col>
            </nz-row>
        }

        @if (usersHelpMaterials.sharePointVideos?.length > 0) {
            <nz-row>
                <nz-col>
                    <h3 class="mb-2 mt-3">SharePoint video</h3>
                    @for (spMaterial of usersHelpMaterials.sharePointVideos; track spMaterial.id) {
                        <div class="mb-3">
                            <h4>{{ spMaterial.displayName }}</h4>
                            <iframe
                                [src]="spMaterial.url | safeSharepoint"
                                width="560"
                                height="315"
                                frameborder="0"
                                scrolling="no"
                                allowfullscreen
                            ></iframe>
                        </div>
                    }
                </nz-col>
            </nz-row>
        }
    } @else {
        <h3>Neviens palīdzības materiāls nav pieejams</h3>
    }

    <div *nzModalFooter class="modal-footer">
        <div class="modal-footer-right">
            <ng-container>
                <button nz-button nzType="default" (click)="close()">Aizvērt</button>
            </ng-container>
        </div>
    </div>
</nz-spin>
